import { i18nFilter } from "app/filters/i18nFilter";
import { percentageSignFilter } from "app/filters/ngFilters";
import { searchOverviewContext } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/SearchOverviewGraphContext";
import { useContext } from "react";
import { BaseMetricGraph } from "../Components/BaseMetricGraph";
import { getBaseChartConfig } from "../Helpers/SearchOverviewGraphConfig";
import { colorsPalettes } from "@similarweb/styles";

export const BounceRateGraph = () => {
    const percentageFormatter = ({ value }) => percentageSignFilter()(value, 2);
    const getChangeColor = (isDecrease: any, isNan: any) =>
        !isNan ? (!isDecrease ? colorsPalettes.red.s100 : colorsPalettes.green.s100) : colorsPalettes.carbon[500];
    const baseChartConfig = getBaseChartConfig(
        [percentageSignFilter, 2],
        i18nFilter()("wa.ao.graph.bounce"),
        percentageFormatter,
        true,
        useContext(searchOverviewContext),
        getChangeColor,
    );
    const rawDataMetricName = "BounceRate";
    const legendsLabelsFormatter = percentageFormatter;
    const chartType = "line";
    const getCurrentChartConfig = () => {
        return {
            ...baseChartConfig,
            yAxis: {
                ...baseChartConfig.yAxis,
                max: 1,
            },
        };
    };
    const metricConfig = {
        getCurrentChartConfig,
        legendsLabelsFormatter,
        rawDataMetricName,
        chartType,
    };
    return <BaseMetricGraph metricConfig={metricConfig} />;
};
